export default __webpack_public_path__ + "static/media/LastPage1.87e387ae.txt";